import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import $ from 'jquery';

import { withStyles } from '@material-ui/core/styles';

import { OverlayElevator, TooltipTypes, Tooltip } from 'components/admin/Help';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
  },
  detail: {
    flexGrow: 1,
  },
  side: {
    width: '350px',
    marginLeft: theme.spacing.unit*2,
  },
  helpOverlay: {
    zIndex: theme.zIndex.overlay + 1,
  },
})

class ContentEdit extends Component {
  constructor(props){
    super(props);
    this.state = {
      sideFixed: false
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  handleScroll() {
    const scrollTop = $(window).scrollTop();
    const appBarHeight = $('#MenuAppBar').height();
    const headerHeight = $('#header').height();
    //const sideTop = $('#side').position().top;

    if ((headerHeight - appBarHeight) < scrollTop) {
      this.setState({sideFixed: true});
    } else {
      this.setState({sideFixed: false});
    }
  }

  render() {
    const { classes, children, showHelp } = this.props;
    const { sideFixed } = this.state;
    const appBarHeight = $('#MenuAppBar').height();
    const windowWidth = $(window).width();

    let header;
    let detail;
    let side;
    let actions;

    //TODO: use a different way to handle content under app bar instead of using
    // style={{marginTop: `${appBarHeight}px`}} on the top element
    React.Children.forEach(children, (child) => {
        switch (child.type.displayName) {
          case 'Actions':
            actions = child;
            break;
          case 'Header':
            header = child;
            break;
          case 'Detail':
            detail = child;
            break;
          case 'Side':
            side = child;
            break;
          default:
        }
    });

    return(
      <div className={classes.root}>
        {sideFixed &&
          <Tooltip type={TooltipTypes.bid.HELP_INFO_PANEL} placement="left">
             <div className={classes.sideFixed}>
               {side}
             </div>
           </Tooltip>
         }
        {actions &&
          <Tooltip type={TooltipTypes.bid.ACTIONS_INFO} placement="bottom-end">
            <div>
              {actions}
            </div>
          </Tooltip>
        }
        <div id="header" className={classes.header} style={{marginTop: `${appBarHeight}px`}}>
          {header}
        </div>
        <div className={classes.content}>
          <div className={classes.detail}>
            {detail}
          </div>
          {windowWidth >= 1400 &&

              <div className={classes.side}>
                {!sideFixed &&
                  <Tooltip type={TooltipTypes.bid.HELP_INFO_PANEL} placement="left">
                    <div>{side}</div>
                  </Tooltip>
                }
              </div>


          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    showHelp: state.help.showHelp,
  });
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(ContentEdit);



// WEBPACK FOOTER //
// ./src/components/admin/ContentEdit/ContentEdit.jsx